import { ReactComponent as AttachIcon } from "../../../Assets/icons/attach.svg";

const Item = ({ name, onDownload, downloadLabel, isFirst, isLast }) => {
  return (
    <div
      className={[
        "acoris-recap__document-item",
        isFirst && "acoris-recap__document-item--first",
        isLast && "acoris-recap__document-item--last",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="acoris-recap__document-item--content">
        <AttachIcon className="acoris-recap__document-item--icon" />
        <span className="acoris-recap__document-item--name">{name}</span>
      </div>
      <button
        type="button"
        className="acoris-recap__document-item--download"
        onClick={onDownload}
      >
        {downloadLabel}
      </button>
    </div>
  );
};

export default Item;
